<template>

  <div
  class="post-media-container"
  :style="{ 'aspect-ratio': postmedia.aspect_ratio }"
  >
  
  <transition name="fade">
    <video
      v-show="loaded"
      v-if="(postmedia.video && !postmedia.vimeo_enable)"
      @canplay="onLoaded"
      class='post-media'
      :preload=true
      playsinline
      autoplay
      muted
      loop
      v-bind:src="postmedia.file_upload"
    >
    </video>

    <div
      v-show="loaded"
      v-else-if="(postmedia.vimeo_enable)"
      class="vimeo-container"
      v-bind:class="{ vimeoSquare: postmedia.vimeo_square }"
    >
      <vimeo-player 
        @ready="onLoaded"
        ref="player"
        class="post-media"
        :video-id="postmedia.vimeo_id"
        :options="vimeoOptions"
      >
      </vimeo-player>
    </div>

    <img
    v-show="loaded"
      v-else class="post-media"
      v-on:load="onLoaded"
      v-bind:src="postmedia.file_upload"
    >

  </transition>
  </div>

</template>

<script>

export default {
  data() {
    return {
      loaded: false,
      vimeoOptions: {
          responsive: true,
      },
    }
  },
  props: {
      postmedia : Object,
  },
  methods: {
    onLoaded() {
      this.loaded = true;
    },
    FileIsVideo(file){
        if (file === null) {
          return false
        }

        let upload = file
               
        // check extension
        let video_extensions = ['mp4']

        // links to aws now are presigned so there is a lot of text after the '?'
        // so split there to get the actual file path
        let file_url = upload.split("?")[0]

        // if file extension is a video
        if (video_extensions.includes(file_url.split(".").pop().toLowerCase())) {
            return true
        }
        else {
            return false
        }
    }
  },
}
</script>

<style lang="scss" scoped>

@import '~bulma/sass/utilities/_all';
@import '../assets/sass/main.scss';

  .fade-enter-active, .fade-leave-active {
    transition: all .2s ease-in;
  }
  .post-media-container {
    // background-color: rgb(66, 40, 40);
    width: 100%;
    text-align: center;
  }
  .post-media {
    box-shadow: 0px 2px 8px -1px #0000000f;
    text-align: center;
    max-width: 100%;
    border-radius: 2px;
    // object-fit: contain;
  }
  .vimeo-container {
    // width: 75vw;
    // margin-left: auto;
    // margin-right: auto;
    // left: 0;
    // right: 0;
  }

  // override class with attribute
  .vimeoSquare {
    // width: 75vh;
  }
  
  @include mobile {
    .post-media {
      max-width: 100%;
    }
    .vimeo-container {
      width: 100vw;
    }
    // override class with attribute
    .vimeoSquare {
      width: 100vw;
    } 
  }

</style>
